var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBuilding = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 33,
  viewBox: "0 0 33 33",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.5444 29.7282V24.3948H20.5444V29.7282M11.2111 8.39483H11.2244M21.8777 8.39483H21.8911M16.5444 8.39483H16.5577M16.5444 13.7282H16.5577M16.5444 19.0615H16.5577M21.8777 13.7282H21.8911M21.8777 19.0615H21.8911M11.2111 13.7282H11.2244M11.2111 19.0615H11.2244M8.54441 3.06149H24.5444C26.0172 3.06149 27.2111 4.2554 27.2111 5.72816V27.0615C27.2111 28.5343 26.0172 29.7282 24.5444 29.7282H8.54441C7.07165 29.7282 5.87775 28.5343 5.87775 27.0615V5.72816C5.87775 4.2554 7.07165 3.06149 8.54441 3.06149Z",
  stroke: "white",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBuilding, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/building.5871a6bb.svg";
export { ForwardRef as ReactComponent };